import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { LabOrderSubject } from 'src/app/Models/labordersubject.model';
import { LabOrderSubjectService } from 'src/app/services/lab-order-subject.service';

@Component({
  selector: 'app-view-lab-order-subject',
  templateUrl: './view-lab-order-subject.component.html',
  styleUrls: ['./view-lab-order-subject.component.css'],
})
export class ViewLabOrderSubjectComponent implements OnInit {
  displayedColumns: string[] = ['Subject', 'Delete'];
  subjectList: LabOrderSubject[] = [];
  dataSource: MatTableDataSource<any>;

  selectedFile: File;

  constructor(private labOrderSubjectService: LabOrderSubjectService) {}

  ngOnInit(): void {
    this.getLabOrderSubject();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getLabOrderSubject() {
    this.labOrderSubjectService.getLabOrderSubjects().subscribe((res) => {
      // this.LabOrderSubjectList = res;

      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
    });
  }

  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.getLabOrderSubject();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0];
  }

  uploadFile() {
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, 'UTF-8');
    fileReader.onload = () => {
      const fileContent = fileReader.result;
      try {
        const data = JSON.parse(fileContent as string);

        // Validate the data structure
        if (!Array.isArray(data.LabOrderSubjectItems)) {
          alert('Invalid data structure');
        }
        data.LabOrderSubjectItems.forEach((sub) => {
          if (typeof sub.Subject !== 'string') {
            alert('Invalid data structure');
          }
          // Add more checks as necessary...
        });

        this.labOrderSubjectService.UploadJsonData(data).subscribe(
          (res) => {
            alert('Upload With success');
            this.getLabOrderSubject();
          },
          (err) => {
            alert('Error uploading the data');
          }
        );
        // this.http.post('https://your-api-url.com/upload', data)
        // .subscribe(
        //     response => console.log(response),
        //     error => console.log(error)
        // );
      } catch (error) {
        console.error('Invalid JSON format:', error);
      }
    };
    fileReader.onerror = (error) => console.log(error);
  }

  deleteSubject(subjectId) {
    this.labOrderSubjectService.deleteLabOrderSubject(subjectId).subscribe(
      (res) => {
        alert('Subject Delete with success');
        this.getLabOrderSubject();
      },
      (err) => {
        alert('Unsuccessful');
      }
    );
  }
}
